import React from "react";
import "./SectionStyle.scss";

import CameraPlayer from "../../../../../container/single/CameraPlayer";

const Section = ({ cameras, title, location }) => {
  return (
    <section id="section-hero">
      <div className="container">
        <div className="wrapper">
          <div className="wrapper-headline">
            <div className="wrapper-headline--title">{title}</div>
            {location && (
              <div className="wrapper-headline--location">{location}</div>
            )}
          </div>

          <div className="wrapper-list">
            {cameras && cameras.length > 0 ? (
              cameras.map((camera) => (
                <div className="item" key={camera.id}>
                  <div className="item-camera">
                    <div className="btn-cam">
                      <CameraPlayer camera={camera} />
                    </div>
                  </div>
                </div>
              ))
            ) : (
              <p>Nenhuma câmera encontrada para esta obra.</p>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Section;
